export const getCombinationsCount = (n: number, k: number): number => {
    const from = n - k + 1;
    const to = n;
    
    // Логика getFactFromTo: начинаем с from, умножаем на все от from+1 до to
    let numerator = from;
    for (let i = from + 1; i <= to; i++) {
        numerator *= i;
    }
    
    // Логика getFact: факториал k
    let denominator = 1;
    for (let i = 1; i <= k; i++) {
        denominator *= i;
    }
    
    return Math.round(numerator / denominator);
};
